// src/services/authHeader.js
import { useAuthStore } from "@/stores/authStore";

export default function authHeader() {
  const store = useAuthStore();
  return store?.token ? { Authorization: `Bearer ${store.token}` } : {};
}
